module.exports = __webpack_public_path__ + "img/home_banner_web_BG6.ecf89caf.png";